import { render, staticRenderFns } from "./ProductSelectionCard.vue?vue&type=template&id=0a531e8e&"
import script from "./ProductSelectionCard.vue?vue&type=script&lang=js&"
export * from "./ProductSelectionCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports